import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Drawer,
  Indicator,
  Text,
  Tabs,
  Title,
  Badge,
  Popover,
  Loader,
  Flex,
  UnstyledButton,
} from "@mantine/core";
import { FiBell } from "react-icons/fi";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { PiWarningFill } from "react-icons/pi";
import {
  getNotifications,
  getNotificationsCount,
  readAllNotifications,
  readNotification,
} from "../../services/notification";
import useStyles from "./style";
import NewNotificationCardComp from "../NewNotificationCardComp";
import NoteModalNew from "../NoteModal/NoteModalNew";
import NoteModal from "../NoteModal";
import { getSkaiTokenUsage } from "../../services/skaiTokens";
import CustomBillingPagination from "../Pagination/CustomBillingPagination";
import { updateChangeSignature } from "../../services/signature";
import SignatureRequestModal from "../SignatureModal";
import NoteDrawer from "../NoteModal/NewNoteDesignCopy";
import SetupTwoFactorModal from "../SetupTwoFactorModal";
import { useDisclosure } from "@mantine/hooks";
import moment from "moment";
import SkyPointHeader from "../SkyPointHeader";
import { isIncompleteAddressDetails } from "../../utils";

const AppNavbar = ({ title, profile, isSidebarOpen }) => {
  const { classes } = useStyles();
  const [isReadAll, setIsReadAll] = useState();
  const [drawerOpened, setDrawerOpened] = useState(false);
  const [popoverOpened, setPopoverOpened] = useState(false);
  const [isLoading, setIsLoading] = useState([]);
  const [readAllLoading, setReadAllLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { singleNote } = useSelector((state) => state?.note);
  const { notifications, getNotificationLoading, notiCount, unreadCount } =
    useSelector((state) => state.notification);
  const [currentTab, setCurrentTab] = useState("all");

  // const { notiCount } = useSelector((state) => state.notification);
  // console.log("🚀 ~ AppNavbar ~ notiCount:", notiCount);

  const [noteType, setNoteType] = useState(null);
  const [isopen, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [billingServices, setBillingServices] = useState("");
  const [progressNoteState, setProgressNoteState] = useState("");
  const [view, setView] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [signatureModalOpened, setSignatureModalOpened] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const navigate = useNavigate();
  const [
    setupTwoFactorModalOpened,
    { open: setupTwoFactorModalOpen, close: setupTwoFactorModalClose },
  ] = useDisclosure(false);

  const handleOpenSignatureModal = (notification) => {
    setSelectedNotification(notification);
    setSignatureModalOpened(true);
  };

  const handleAcceptSignature = async () => {
    const payload = {
      signatureId: selectedNotification?.moduleId,
      staffId: selectedNotification?.staff?.id,
    };
    await updateChangeSignature(payload);
    setSignatureModalOpened(false);
  };

  // useEffect(() => {
  //   getNotificationsCount();
  // }, [notiCount]);

  const handleNotificationClick = () => {
    if (profile?.user?.type != "staff") {
      setIsOpen(true);
    } else {
      setOpen(true);
    }
  };
  const handleNotifyBillClick = () => {
    setPopoverOpened((prev) => !prev);
    getNotifications({ page: 1, limit: 10, client: "" });
    getSkaiTokenUsage(profile?.user?.admin || profile?.user?.id);
  };

  let countUnreadNotif = 0;

  const allNotifications = Object.values(notifications).flat();

  const isAnyNotification = allNotifications?.map((notification) =>
    notification?.readedUsers?.includes(profile?.user?.id)
  );

  allNotifications.forEach((notification) => {
    if (notification?.readedUsers?.length === 0) {
      countUnreadNotif++;
    }
  });

  // const getData = async () => {
  //   try {
  //     let data = {
  //       page: 1,
  //       perPage: 2,
  //     };
  //     await getNotifications({
  //       page: data?.page,
  //       perPage: data?.perPage,
  //       client: "",
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getData = async (pageNum = 1) => {
    try {
      // let data = {
      //   page: pageNum,
      //   perPage: 10, // match backend limit
      // };
      const res = await getNotifications({
        page: pageNum,
        limit: 10,
        client: "",
        filter: currentTab === "unread" ? "unread" : undefined,
      });

      // assuming backend returns { notifications, totalPages }
      if (res) {
        // you'll probably need to set notifications in Redux or state
        // dispatch(setNotifications(res.notifications));
        setTotalPages(res.totalPages || 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleViewAll = () => {
    getData();
    setPopoverOpened(false);
    setDrawerOpened(true);
  };

  const handleReadNotification = async (notificationId) => {
    setIsLoading((prev) => [...prev, notificationId]);
    try {
      const response = await readNotification(notificationId);
      if (response) {
        await getData();
      }
    } catch (error) {
      console.log(error);
    } finally {
      await getData();
      setIsLoading((prev) => prev?.filter((id) => id !== notificationId));
    }
  };

  const handleReadAllNotifications = async () => {
    try {
      setReadAllLoading(true);
      const response = await readAllNotifications();
      if (response) {
        return response?.message;
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      await getData();
      setReadAllLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [currentTab]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    getData(newPage);
  };

  const navigateToUpdateCard = () => {
    // navigate(`/home/settings`, { state: { selectedTab: "method" } });
    navigate("/add-payment");
  };

  const navToSettingBusinessTab = () => {
    navigate(`/home/settings`, { state: { selectedTab: "business" } });
  };

  const currentDate = profile?.currentDate
    ? new Date(profile?.currentDate)
    : new Date();
  const cutoffDate = new Date("2026-1-30");
  return (
    <>
      <Box w={"100%"}>
        {!profile?.user?.role && profile?.subscription?.subscriptionFailed ? (
          <Flex className={classes.paymentFailBanner}>
            <PiWarningFill size={20} color="#FFF" />
            <p className="text">
              Your payment was unsuccessful. Please{" "}
              <UnstyledButton onClick={navigateToUpdateCard} className="link">
                update
              </UnstyledButton>{" "}
              your payment method to maintain your subscription.
            </p>
          </Flex>
        ) : null}
        {/* {currentDate <= cutoffDate && profile?.user?.twoFactorVerified === false ? ( */}
        {profile?.user?.twoFactorVerified === false ? (
          <Flex className={classes.paymentFailBanner}>
            <PiWarningFill size={20} color="#FFF" />
            <p className="text">
              <UnstyledButton
                className="link"
                onClick={setupTwoFactorModalOpen}
              >
                Setup two factor authentication
              </UnstyledButton>{" "}
              to protect client data.
              {/* Non compliant users will be required to enroll
              by {moment(cutoffDate).format("MM/DD/YYYY")} */}
            </p>
          </Flex>
        ) : null}

        {/* {currentDate <= cutoffDate && isIncompleteAddressDetails(profile) ? (
          <Flex className={classes.paymentFailBanner}>
            <PiWarningFill size={20} color="#FFF" />
            <p className="text">
              <UnstyledButton
                className="link"
                onClick={navToSettingBusinessTab}
              >
                Incomplete address information
              </UnstyledButton>{" "}
              Please complete your address details. Non compliant users will be
              required to enroll by {moment(cutoffDate).format("MM/DD/YYYY")}
            </p>
          </Flex>
        ) : null} */}

        <Box className={classes.container}>
          <Box className={classes.left}>
            <Title order={2} pl={6} tt={"capitalize"}>
              {title}
            </Title>
          </Box>
          <Box className={classes.right}>
            <Popover
              trapFocus
              shadow="md"
              radius={10}
              offset={10}
              width={600}
              position="bottom-end"
              opened={popoverOpened}
              onChange={setPopoverOpened}
            >
              <Popover.Target>
                <Box
                  className={classes.notificationBorder}
                  onClick={handleNotifyBillClick}
                >
                  {isAnyNotification?.includes(false) ? (
                    <Indicator
                      color="red"
                      size={10}
                      inline
                      disabled={!isAnyNotification}
                    >
                      <FiBell size={24} style={{ margin: "0.3rem" }} />
                    </Indicator>
                  ) : (
                    <FiBell size={24} style={{ margin: "0.3rem" }} />
                  )}
                </Box>
              </Popover.Target>
              <Popover.Dropdown>
                {getNotificationLoading ? (
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "1rem",
                      height: "500px",
                    }}
                  >
                    <Loader color="yellow" size="md" />
                  </Box>
                ) : (
                  <>
                    <Box className={classes.header}>
                      <Box className={classes.headerTitle}>
                        <Title order={3} fw={600}>
                          Notification
                        </Title>
                        {/* {countUnreadNotif > 0 && ( */}
                        {unreadCount > 0 && (
                          <Badge
                            variant="light"
                            color="red"
                            radius="xl"
                            size="md"
                          >
                            {unreadCount}
                            {/* {countUnreadNotif} New */}
                          </Badge>
                        )}
                      </Box>

                      <Button
                        loading={readAllLoading}
                        onClick={
                          isAnyNotification?.includes(false) &&
                          handleReadAllNotifications
                        }
                        variant="transparent"
                        color="yellow"
                        className={classes.readAllButton}
                      >
                        Read All
                      </Button>
                    </Box>
                    <Box className={classes.body}>
                      {notifications?.today?.length > 0 && (
                        <>
                          <Text ff="Inter" size="md" fw={400}>
                            Today
                          </Text>
                          {notifications?.today?.map((notification, index) => (
                            <NewNotificationCardComp
                              key={notification.id} // add key if available
                              notification={notification}
                              handleReadNotification={handleReadNotification}
                              isLoading={isLoading}
                              isReadAll={isReadAll}
                              profile={profile}
                              onOpenSignatureModal={handleOpenSignatureModal} // ✅ pass down
                              onClickNotification={handleNotificationClick}
                            />
                          ))}
                        </>
                      )}

                      {notifications?.yesterday?.length > 0 && (
                        <>
                          <Text ff={"Inter"} size="md" fw={400}>
                            Yesterday
                          </Text>

                          {notifications?.yesterday?.map((notification) => (
                            <NewNotificationCardComp
                              notification={notification}
                              handleReadNotification={handleReadNotification}
                              isLoading={isLoading}
                              isReadAll={isReadAll}
                              profile={profile}
                              onOpenSignatureModal={handleOpenSignatureModal} // ✅ pass down
                              onClickNotification={handleNotificationClick}
                            />
                          ))}
                        </>
                      )}

                      {notifications?.restOfThreeMonths?.length > 0 && (
                        <>
                          <Text ff={"Inter"} size="md" fw={400}>
                            Older
                          </Text>

                          {notifications?.restOfThreeMonths?.map(
                            (notification) => (
                              <NewNotificationCardComp
                                notification={notification}
                                handleReadNotification={handleReadNotification}
                                isLoading={isLoading}
                                isReadAll={isReadAll}
                                profile={profile}
                                onOpenSignatureModal={handleOpenSignatureModal} // ✅ pass down
                                onClickNotification={handleNotificationClick}
                              />
                            )
                          )}
                        </>
                      )}
                    </Box>
                    <Box className={classes.footer}>
                      <Button
                        size="md"
                        fullWidth
                        c={"#000"}
                        variant="white"
                        onClick={handleViewAll}
                      >
                        View All
                      </Button>
                    </Box>
                  </>
                )}
              </Popover.Dropdown>
            </Popover>
            <NavLink to={"/home/settings"}>
              <Avatar
                size="lg"
                radius="xl"
                src={profile?.user?.photo}
                style={{ cursor: "pointer" }}
              />
            </NavLink>
          </Box>
        </Box>
      </Box>

      {/* <UploadStaffDoc
        selectedFolder={n?.folder}
        userId={n?.userId}
        isDocument={true}
        uploadedFiles={n?.file}
      /> */}

      {/* view note drawer */}
      <NoteModalNew
        view={true}
        opened={isOpen}
        data={singleNote}
        title={"View Note"}
        close={() => setIsOpen(false)}
      />

      {/* edit note modal */}
      {/* <NoteModal */}
      <NoteDrawer
        data={singleNote}
        view={view}
        opened={isopen}
        setView={setView}
        noteType={noteType}
        title={"Add New Note"}
        close={() => {
          setOpen(false);
          setData(null);
          setNoteType(null);
        }}
        // sortField={sortField}
        // sortOrder={sortOrder}
        setOpenModal={setOpenModal}
        setBillingServices={setBillingServices}
        setProgressNoteState={setProgressNoteState}
        progressNoteState={progressNoteState}
        // selectedPatient={selectedPatient}
        // setSelectedPatient={setSelectedPatient}
      />

      <SignatureRequestModal
        opened={signatureModalOpened}
        onClose={() => setSignatureModalOpened(false)}
        onAccept={handleAcceptSignature}
        notification={selectedNotification}
      />

      <SetupTwoFactorModal
        opened={setupTwoFactorModalOpened}
        close={setupTwoFactorModalClose}
        profile={profile}
        isNavbar={true}
      />

      <Drawer
        size="35%"
        offset={8}
        radius="md"
        zIndex={1000}
        position="right"
        title="Notifications"
        opened={drawerOpened}
        className={classes.drawer}
        onClose={() => setDrawerOpened(false)}
      >
        {getNotificationLoading ? (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1rem",
              marginTop: "1rem",
            }}
          >
            <Loader color="yellow" size="md" />
          </Box>
        ) : (
          <Box className={classes.drawer}>
            <Tabs
              radius="md"
              color="gray"
              variant="default"
              defaultValue="all"
              value={currentTab}
              onTabChange={(value) => {
                if (value) {
                  setCurrentTab(value);
                  setPage(1);
                }
              }}
              className={classes.tabs}
            >
              <Tabs.List className={classes.tabsList}>
                <Tabs.Tab value="all">All</Tabs.Tab>
                <Tabs.Tab value="unread">Unread</Tabs.Tab>
              </Tabs.List>

              <Tabs.Panel value="all">
                {/* -----> Today <----- */}

                {notifications?.today?.length > 0 && (
                  <Box>
                    <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                      Today
                    </Text>
                    {notifications?.today?.map((notification) => (
                      <Box mt={"1rem"}>
                        <NewNotificationCardComp
                          notification={notification}
                          handleReadNotification={handleReadNotification}
                          isLoading={isLoading}
                          isReadAll={isReadAll}
                          profile={profile}
                          onClickNotification={handleNotificationClick}
                          onOpenSignatureModal={handleOpenSignatureModal} // ✅ pass down
                        />
                      </Box>
                    ))}
                  </Box>
                )}

                {/* -----> Yesterday <----- */}

                {notifications?.yesterday?.length > 0 && (
                  <Box>
                    <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                      Yesterday
                    </Text>
                    {notifications?.yesterday?.map((notification) => (
                      <Box mt={"1rem"}>
                        <NewNotificationCardComp
                          notification={notification}
                          handleReadNotification={handleReadNotification}
                          isLoading={isLoading}
                          isReadAll={isReadAll}
                          profile={profile}
                          onClickNotification={handleNotificationClick}
                          onOpenSignatureModal={handleOpenSignatureModal}
                        />
                      </Box>
                    ))}
                  </Box>
                )}

                {/* -----> Rest of three months <-----  */}

                {notifications?.restOfThreeMonths?.length > 0 && (
                  <Box>
                    <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                      Older
                    </Text>
                    {notifications?.restOfThreeMonths?.map((notification) => (
                      <Box mt={"1rem"}>
                        <NewNotificationCardComp
                          notification={notification}
                          handleReadNotification={handleReadNotification}
                          isLoading={isLoading}
                          isReadAll={isReadAll}
                          profile={profile}
                          onClickNotification={handleNotificationClick}
                          onOpenSignatureModal={handleOpenSignatureModal}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
                <CustomBillingPagination
                  data={notiCount}
                  itemsPerPage={10}
                  currentPage={page}
                  handlePageChange={handlePageChange}
                />
              </Tabs.Panel>
              <Tabs.Panel value="unread">
                <Box>
                  {notifications?.today?.length > 0 ||
                  notifications?.yesterday?.length > 0 ||
                  notifications?.restOfThreeMonths?.length > 0 ? (
                    <>
                      {/* -----> Today <----- */}

                      {notifications?.today?.length > 0 && (
                        <Box>
                          <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                            Today
                          </Text>
                          {notifications?.today?.map((notification) => (
                            <Box mt={"1rem"}>
                              <NewNotificationCardComp
                                notification={notification}
                                handleReadNotification={handleReadNotification}
                                isLoading={isLoading}
                                isReadAll={isReadAll}
                                profile={profile}
                                onClickNotification={handleNotificationClick}
                                onOpenSignatureModal={handleOpenSignatureModal} // ✅ pass down
                              />
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* -----> Yesterday <----- */}

                      {notifications?.yesterday?.length > 0 && (
                        <Box>
                          <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                            Yesterday
                          </Text>
                          {notifications?.yesterday?.map((notification) => (
                            <Box mt={"1rem"}>
                              <NewNotificationCardComp
                                notification={notification}
                                handleReadNotification={handleReadNotification}
                                isLoading={isLoading}
                                isReadAll={isReadAll}
                                profile={profile}
                                onClickNotification={handleNotificationClick}
                                onOpenSignatureModal={handleOpenSignatureModal}
                              />
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* -----> Rest of three months <-----  */}

                      {notifications?.restOfThreeMonths?.length > 0 && (
                        <Box>
                          <Text ff={"Inter"} size="md" fw={400} mt={"1rem"}>
                            Older
                          </Text>
                          {notifications?.restOfThreeMonths?.map(
                            (notification) => (
                              <Box mt={"1rem"}>
                                <NewNotificationCardComp
                                  notification={notification}
                                  handleReadNotification={
                                    handleReadNotification
                                  }
                                  isLoading={isLoading}
                                  isReadAll={isReadAll}
                                  profile={profile}
                                  onClickNotification={handleNotificationClick}
                                  onOpenSignatureModal={
                                    handleOpenSignatureModal
                                  }
                                />
                              </Box>
                            )
                          )}
                        </Box>
                      )}
                      <CustomBillingPagination
                        data={notiCount}
                        itemsPerPage={10}
                        currentPage={page}
                        handlePageChange={handlePageChange}
                      />
                    </>
                  ) : (
                    <Box className={classes.empty}>
                      <Text size="md" color="#737373" fw={400} ff={"Inter"}>
                        No unread notification.
                      </Text>
                    </Box>
                  )}
                </Box>
              </Tabs.Panel>
            </Tabs>
          </Box>
        )}
      </Drawer>
    </>
  );
};

export default AppNavbar;
